/** The two kinds of job in the page's one history: ID photos (`GET /api/jobs`) and editor jobs (`GET /api/edit/jobs`). */
import type { Job } from "../api";
import { SHARPEN_QUEUE } from "../editor/SharpenCard";

/** Queues edit / edit-ai / edit-cloud / edit-sharpen (server models.EDIT_JOB_QUEUES). */
export function isEditJob(job: Job): boolean {
  return job.queue.startsWith("edit");
}

export function isSharpenJob(job: Job): boolean {
  return job.queue === SHARPEN_QUEUE;
}

/** "Làm đẹp nhanh" › "Render cả 4 mức". */
export function isVariantsJob(job: Job): boolean {
  return (job.settings as unknown as { mode?: string }).mode === "variants";
}

/** Both lists as one, newest first. */
export function mergeJobs(idPhotos: Job[], edits: Job[]): Job[] {
  const seen = new Set<string>();
  return [...idPhotos, ...edits]
    .filter((j) => !seen.has(j.id) && Boolean(seen.add(j.id)))
    .sort((a, b) => Date.parse(b.created_at) - Date.parse(a.created_at));
}
